import API from "../../../api/axiosClient";
import {
    CoordinatorDto,
    CreateGroupDto,
    GroupDto,
    UpdateGroupDto,
    GroupImportResultDto,
    SearchSuggestion,
} from "../types/Group";

const url = "Group";

const GroupService = {

    getAll: async (): Promise<GroupDto[]> => {
        const response = await API.get(url);
        return response.data;
    },

    getById: async (groupId: string): Promise<GroupDto> => {
        const response = await API.get(`${url}/${groupId}`);
        return response.data;
    },

    // ✅ NEW
    getBySlug: async (slug: string): Promise<GroupDto> => {
        const response = await API.get(`${url}/slug/${slug}`);
        return response.data;
    },

    search: async (keyword: string): Promise<GroupDto[]> => {
        const response = await API.get(`${url}/search-by-group`, {
            params: { keyword }
        });

        return response.data;
    },

    getSearchSuggestions: async (
        keyword: string
    ): Promise<SearchSuggestion[]> => {

        const response = await API.get(
            `${url}/search-suggestions`,
            {
                params: {
                    keyword
                }
            });

        return response.data;
    },

    create: async (data: CreateGroupDto): Promise<string> => {
        const response = await API.post(url, data);
        return response.data;
    },

    update: async (
        groupId: string,
        data: UpdateGroupDto
    ): Promise<void> => {
        await API.put(`${url}/${groupId}`, data);
    },

    delete: async (groupId: string): Promise<void> => {
        await API.delete(`${url}/${groupId}`);
    },

    getCoordinators: async (): Promise<CoordinatorDto[]> => {
        const response = await API.get(`${url}/coordinators`);
        return response.data;
    },

    importExcel: async (
        groupFile: File
    ): Promise<GroupImportResultDto> => {

        const formData = new FormData();

        formData.append("groupFile", groupFile);

        const response = await API.post(
            `${url}/import`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;
    },

};

export default GroupService;